const ExportImport = () => {
  return <div>Uvoz/izvoz</div>
}

export default ExportImport
